import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '~/app/router.tsx';
import { MsalProvider } from '~/features/auth/msal-provider.tsx';

import { InnerApp } from './inner-app.tsx';

export function App() {
  return (
    <MsalProvider>
      <QueryClientProvider client={queryClient}>
        <InnerApp />
      </QueryClientProvider>
    </MsalProvider>
  );
}
